import { __decorate } from "tslib";
import { id_netscapeCertExtension } from "./object_identifiers";
import { AsnType, AsnTypeTypes, AsnPropTypes, AsnProp } from "@peculiar/asn1-schema";
export const id_netscapeComment = `${id_netscapeCertExtension}.13`;
let NetscapeComment = class NetscapeComment {
    constructor(value) {
        this.value = "";
        if (value) {
            this.value = value;
        }
    }
};
__decorate([
    AsnProp({ type: AsnPropTypes.IA5String })
], NetscapeComment.prototype, "value", void 0);
NetscapeComment = __decorate([
    AsnType({ type: AsnTypeTypes.Choice })
], NetscapeComment);
export { NetscapeComment };
